import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import { icon } from './ui';
import ServerStatus from './ServerStatus';
import SiteSidebar from './SiteSidebar';
export default class ServerPage extends Page {
  oncreate() {
    window.scrollTo(0, 0);
  }
  view() {
    const address = String(app.forum.attribute('novatruckServerAddress') || '51.83.182.99:20236').replace(/^mtasa:\/\//i, '');
    const joinUrl = `mtasa://${address}`;
    return m("div", {
      className: "NtServerPage"
    }, m("section", {
      className: "NtServerHero"
    }, m("div", {
      className: "container"
    }, m("span", {
      className: "NtServerHero-kicker"
    }, "NOVA NETWORK"), m("h1", null, "NovaTruck & RP"), m("p", null, "Truck \u2022 RPG \u2022 Light RP \u2022 rozwijaj\u0105cy si\u0119 \u015Bwiat San Andreas"), m("a", {
      className: "Button Button--primary NtServerJoin",
      href: joinUrl
    }, icon('fas fa-play'), " DO\u0141\u0104CZ DO SERWERA"))), m(ServerStatus, null), m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", {
      className: "NtServerContent"
    }, m("div", {
      className: "NtServerGrid"
    }, m("section", {
      className: "NtServerCard"
    }, m("span", null, icon('fas fa-truck')), m("div", null, m("small", null, "Rozgrywka"), m("strong", null, "Transport i logistyka"), m("p", null, "Trasy ci\u0119\u017Carowe, zlecenia, w\u0142asne pojazdy i rozw\xF3j kariery."))), m("section", {
      className: "NtServerCard"
    }, m("span", null, icon('fas fa-city')), m("div", null, m("small", null, "\u015Awiat gry"), m("strong", null, "RPG i Light RP"), m("p", null, "Prace, biznesy, nieruchomo\u015Bci, organizacje oraz miejskie s\u0142u\u017Cby."))), m("section", {
      className: "NtServerCard"
    }, m("span", null, icon('fas fa-map-marker-alt')), m("div", null, m("small", null, "Po\u0142\u0105czenie"), m("strong", null, address), m("p", null, "Uruchom MTA:SA 1.6 i u\u017Cyj przycisku do\u0142\u0105czania powy\u017Cej.")))), m("section", {
      className: "NtServerSection"
    }, m("header", null, m("small", null, "MO\u017BLIWO\u015ACI SERWERA"), m("h2", null, "Tw\xF3rz w\u0142asn\u0105 histori\u0119"), m("p", null, "NovaTruck \u0142\u0105czy rozbudowany transport z \u017Cywym \u015Bwiatem RPG i lekkim roleplayem.")), m("div", {
      className: "NtFeatureGrid"
    }, m("article", null, icon('fas fa-briefcase'), m("strong", null, "Prace i kariery"), m("span", null, "Rozwijaj specjalizacje, reputacj\u0119 i poziom do\u015Bwiadczenia.")), m("article", null, icon('fas fa-car'), m("strong", null, "W\u0142asne pojazdy"), m("span", null, "Kupuj, rozwijaj, serwisuj i personalizuj swoj\u0105 flot\u0119.")), m("article", null, icon('fas fa-building'), m("strong", null, "Biznesy i maj\u0105tek"), m("span", null, "Posiadaj nieruchomo\u015Bci, firmy i \u017Ar\xF3d\u0142a dochodu.")), m("article", null, icon('fas fa-users'), m("strong", null, "Organizacje"), m("span", null, "Do\u0142\u0105cz do frakcji, firmy transportowej albo w\u0142asnej ekipy.")), m("article", null, icon('fas fa-trophy'), m("strong", null, "Rankingi"), m("span", null, "Rywalizuj poziomem, reputacj\u0105 oraz wynikami zawodowymi.")), m("article", null, icon('fas fa-sync-alt'), m("strong", null, "NovaID"), m("span", null, "Jedno konto \u0142\u0105czy serwer MTA, forum oraz Discord.")))), m("section", {
      className: "NtConnectPanel"
    }, m("div", null, m("small", null, "SZYBKIE PO\u0141\u0104CZENIE"), m("h2", null, "Gotowy do gry?"), m("p", null, "Wymagane jest GTA: San Andreas oraz aktualny klient MTA:SA 1.6."), m("code", null, joinUrl)), m("a", {
      className: "Button Button--primary",
      href: joinUrl
    }, icon('fas fa-play'), " URUCHOM MTA:SA")))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/ServerPage', ServerPage);